export const getAuthenticationToken = () => {
  const token = localStorage.getItem('tokens'); // Retrieve the token from localStorage. The token will be used if the user refreshes the page.
  return token;
};

export { getAuthenticationToken as default };
